// import React, { useState, useEffect } from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import MetaTags from 'react-meta-tags';
// import Breadcrumb from '../../components/Common/Breadcrumb';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import {
//   Button,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogActions,
//   DialogContent,
//   TextField,
//   Checkbox,
//   FormControlLabel,
//   Typography,
//   Box,
//   Grid,
//   CircularProgress,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Alert,
// } from '@mui/material';
// import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import FeatherIcon from 'feather-icons-react';
// import jwtDecode from 'jwt-decode';
// import axios from '../api/axios';
// import {
//   getPropertyList,
//   getInventory,
//   createInventory,
//   createInventoryItem,
//   updateInventoryItem,
//   deleteInventoryItem,
//   checkItemExists,
//   createOrder,
//   appendInventoryItemQuantity,
// } from './utils/api';
// import '../../assets/css/rentdigicare.css';

// // MIUI-inspired styles
// const miuiStyles = `
//   .miui-card {
//     border-radius: 16px;
//     box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//     background: #fff;
//     margin-bottom: 20px;
//   }
//   .miui-button {
//     border-radius: 20px;
//     padding: 8px 24px;
//     font-weight: 500;
//     text-transform: none;
//     transition: all 0.3s ease;
//   }
//   .miui-dialog {
//     .MuiDialog-paper {
//       border-radius: 16px;
//       box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//       background: #fff;
//       min-width: 600px;
//     }
//     .MuiDialogTitle-root {
//       border-bottom: none;
//       padding: 20px 24px;
//       background: #f8f9fa;
//       border-radius: 16px 16px 0 0;
//     }
//     .MuiDialogActions-root {
//       border-top: none;
//       padding: 16px 24px;
//     }
//     .MuiDialogContent-root {
//       padding: 20px 24px;
//     }
//   }
//   .miui-form-field {
//     margin-bottom: 16px;
//   }
//   .miui-table {
//     border-radius: 12px;
//     overflow: hidden;
//     background: #fff;
//     .table {
//       margin-bottom: 0;
//     }
//     .table thead th {
//       background: #f8f9fa;
//       border-bottom: none;
//       padding: 16px;
//       font-weight: 500;
//       color: #333;
//     }
//     .table td {
//       padding: 16px;
//       vertical-align: middle;
//     }
//   }
//   .scrollable-table {
//     max-height: 600px;
//     overflow-y: auto;
//     position: relative;
//   }
//   .loader-container {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     min-height: 200px;
//   }
// `;

// // Validation schema for form
// const validationSchema = Yup.object().shape({
//   request_type: Yup.string().required('Request type is required'),
//   name: Yup.string().required('Name is required'),
//   sku: Yup.string().required('SKU is required'),
//   building_name: Yup.string().required('Building name is required'),
//   description: Yup.string(),
//   quantity: Yup.number()
//     .required('Quantity is required')
//     .min(0, 'Quantity cannot be negative')
//     .typeError('Quantity must be a number'),
//   min_quantity: Yup.number()
//     .required('Min quantity is required')
//     .min(0, 'Min quantity cannot be negative')
//     .typeError('Min quantity must be a number'),
//   max_quantity: Yup.number()
//     .required('Max quantity is required')
//     .min(0, 'Max quantity cannot be negative')
//     .typeError('Max quantity must be a number'),
//   cost_per_unit: Yup.number()
//     .required('Cost per unit is required')
//     .min(0, 'Cost per unit cannot be negative')
//     .typeError('Cost per unit must be a number'),
//   is_active: Yup.boolean(),
//   recurring: Yup.boolean(),
//   location_details: Yup.object().shape({
//     floor: Yup.string(),
//     room: Yup.string(),
//     section: Yup.string(),
//     shelf: Yup.string(),
//     bin: Yup.string(),
//     notes: Yup.string(),
//   }),
//   invoice_details: Yup.object().shape({
//     invoice_url: Yup.string(),
//     warranty_details: Yup.object().shape({
//       valid_till: Yup.string(),
//       provider: Yup.string(),
//       contact: Yup.string(),
//       notes: Yup.string(),
//     }),
//   }),
// });

// const CreateInventory = () => {
//   const [inventories, setInventories] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [detailModalOpen, setDetailModalOpen] = useState(false);
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [noBuildingsModalOpen, setNoBuildingsModalOpen] = useState(false);
//   const [noInventoryModalOpen, setNoInventoryModalOpen] = useState(false);
//   const [selectedInventory, setSelectedInventory] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [propertyList, setPropertyList] = useState([]);
//   const [selectedProperty, setSelectedProperty] = useState(null);
//   const [buildingList, setBuildingList] = useState([]);
//   const [selectedBuilding, setSelectedBuilding] = useState('');
//   const [inventoryId, setInventoryId] = useState(null);
//   const [pendingItems, setPendingItems] = useState(() => {
//     const saved = localStorage.getItem('pendingItems');
//     return saved ? JSON.parse(saved) : [];
//   });
//   const [requestTypes, setRequestTypes] = useState([]);

//   // Decode JWT with error handling
//   let userData = { role: 'company', id: '62c4307c5dba72e1eb1b6493' };
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (token) {
//       const decoded = jwtDecode(token);
//       userData = { role: decoded.role || 'company', id: decoded.id || '62c4307c5dba72e1eb1b6493' };
//     } else {
//       console.error('No access token found');
//       toast.error('Please log in to continue');
//     }
//   } catch (error) {
//     console.error('Error decoding JWT:', error);
//     toast.error('Invalid session. Please log in again.');
//   }

//   // Inject MIUI styles and fetch data on mount
//   useEffect(() => {
//     const styleSheet = document.createElement('style');
//     styleSheet.textContent = miuiStyles;
//     document.head.appendChild(styleSheet);
//     getPropertyListData();
//     getRequestTypesData();
//     return () => document.head.removeChild(styleSheet);
//   }, []);

//   // Save pending items to localStorage
//   useEffect(() => {
//     localStorage.setItem('pendingItems', JSON.stringify(pendingItems));
//   }, [pendingItems]);

//   // Fetch request types
//   const getRequestTypesData = async () => {
//     try {
//       const response = await axios.post("requesttype/getrequest", {
//         company_id: userData.id,
//       });
//       if (response.data.requestType) {
//         const temp = response.data.requestType.reverse();
//         setRequestTypes(temp);
//       }
//     } catch (error) {
//       console.error('Error fetching request types:', error);
//       toast.error('Failed to fetch request types. Please try again.');
//     }
//   };

//   // Fetch property list
//   const getPropertyListData = async () => {
//     try {
//       setLoading(true);
//       const result = await getPropertyList(userData.role, userData.id);
//       const properties = result?.propertyList || [];
//       setPropertyList(properties);
//       if (properties.length === 0) {
//         setNoBuildingsModalOpen(true);
//       }
//     } catch (error) {
//       console.error('Error fetching properties:', error);
//       toast.error('Failed to fetch properties. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle property selection
//   const handlePropertyChange = (event) => {
//     const propertyId = event.target.value;
//     const selected = propertyList.find((prop) => prop._id === propertyId);
//     if (selected) {
//       const propertyData = {
//         id: selected._id,
//         value: selected.title,
//         label: `${selected.title}, ${selected.location}`,
//         building: selected.building || [],
//       };
//       setSelectedProperty(propertyData);
//       const buildings = selected.building
//         .map((b) => b.buildingName)
//         .filter((name) => name);
//       setBuildingList(buildings);
//       setSelectedBuilding('');
//       setInventories([]);
//       setInventoryId(null);
//       if (buildings.length === 0) {
//         setNoBuildingsModalOpen(true);
//       } else {
//         setNoBuildingsModalOpen(false);
//       }
//     }
//   };

//   // Handle building selection
//   const handleBuildingChange = (event) => {
//     const buildingName = event.target.value;
//     setSelectedBuilding(buildingName);
//     if (buildingName) {
//       getInventoryData(selectedProperty.id, buildingName);
//     } else {
//       setInventories([]);
//       setInventoryId(null);
//       setNoInventoryModalOpen(false);
//     }
//   };

//   // Fetch inventory data
//   const getInventoryData = async (propertyId, buildingName) => {
//     setLoading(true);
//     try {
//       const response = await getInventory(propertyId, buildingName);
//       const { inventory, items } = response;
//       if (inventory) {
//         setInventoryId(inventory._id);
//         setInventories(items || []);
//         setNoInventoryModalOpen(items.length === 0);
//       } else {
//         setInventoryId(null);
//         setInventories([]);
//         setNoInventoryModalOpen(true);
//       }
//     } catch (error) {
//       console.error('Error checking inventory:', error);
//       toast.error('Failed to fetch inventory. Please try again.');
//       setInventories([]);
//       setInventoryId(null);
//       setNoInventoryModalOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Add item to pending list or append to existing item
//   const handleAddMoreItem = async (values, { resetForm }) => {
//     try {
//       setLoading(true);

//       // Validate required fields
//       if (!values.request_type || !values.name || !values.sku) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       // Check if inventory exists, create if not
//       let currentInventoryId = inventoryId;
//       if (!currentInventoryId) {
//         const inventoryPayload = {
//           property_id: selectedProperty.id,
//           building_name: selectedBuilding,
//         };
//         const inventoryResponse = await createInventory(inventoryPayload);
//         currentInventoryId = inventoryResponse.inventory._id;
//         setInventoryId(currentInventoryId);
//       }

//       // Check if item exists
//       const exists = await checkItemExists(
//         selectedProperty.id,
//         selectedBuilding,
//         values.sku
//       );

//       if (exists.exists) {
//         // Item exists, append quantity
//         const existingItem = inventories.find((item) => item.sku.includes(values.sku));
//         if (existingItem) {
//           const appendPayload = {
//             inventory_item_id: existingItem._id,
//             quantity: Number(values.quantity),
//           };
//           await appendInventoryItemQuantity(appendPayload);
//           toast.success('Quantity added to existing item');
//         } else {
//           toast.error('Item found but could not append quantity');
//           return;
//         }
//       } else {
//         // Item does not exist, add to pending list
//         setPendingItems((prev) => [
//           ...prev,
//           {
//             ...values,
//             property_id: selectedProperty.id,
//             building_name: selectedBuilding,
//             quantity: Number(values.quantity),
//             min_quantity: Number(values.min_quantity),
//             max_quantity: Number(values.max_quantity),
//             cost_per_unit: Number(values.cost_per_unit),
//             sku: [values.sku],
//           },
//         ]);
//         toast.success('Item added to pending list');
//       }

//       resetForm();
//     } catch (error) {
//       console.error('Error handling item addition:', error);
//       toast.error(error.message || 'Failed to process item. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Submit all items (pending + current)
//   const handleAddSubmit = async (values, { setSubmitting, resetForm }) => {
//     setLoading(true);
//     try {
//       // Validate required fields
//       if (!values.request_type || !values.name || !values.sku) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       // Check if inventory exists, create if not
//       let currentInventoryId = inventoryId;
//       if (!currentInventoryId) {
//         const inventoryPayload = {
//           property_id: selectedProperty.id,
//           building_name: selectedBuilding,
//         };
//         const inventoryResponse = await createInventory(inventoryPayload);
//         currentInventoryId = inventoryResponse.inventory._id;
//         setInventoryId(currentInventoryId);
//       }

//       // Check if current item exists
//       const exists = await checkItemExists(
//         selectedProperty.id,
//         selectedBuilding,
//         values.sku
//       );
//       if (exists.exists) {
//         const existingItem = inventories.find((item) => item.sku.includes(values.sku));
//         if (existingItem) {
//           const appendPayload = {
//             inventory_item_id: existingItem._id,
//             quantity: Number(values.quantity),
//           };
//           await appendInventoryItemQuantity(appendPayload);
//         } else {
//           toast.error('Item found but could not append quantity');
//           return;
//         }
//       } else {
//         // Add current item to pending items
//         setPendingItems((prev) => [
//           ...prev,
//           {
//             ...values,
//             property_id: selectedProperty.id,
//             building_name: selectedBuilding,
//             quantity: Number(values.quantity),
//             min_quantity: Number(values.min_quantity),
//             max_quantity: Number(values.max_quantity),
//             cost_per_unit: Number(values.cost_per_unit),
//             sku: [values.sku],
//           },
//         ]);
//       }

//       // Save all pending items
//       for (const item of pendingItems) {
//         const exists = await checkItemExists(
//           selectedProperty.id,
//           selectedBuilding,
//           item.sku[0]
//         );
//         if (exists.exists) {
//           const existingItem = inventories.find((i) => i.sku.includes(item.sku[0]));
//           if (existingItem) {
//             const appendPayload = {
//               inventory_item_id: existingItem._id,
//               quantity: Number(item.quantity),
//             };
//             await appendInventoryItemQuantity(appendPayload);
//           }
//         } else {
//           const itemPayload = {
//             ...item,
//             inventory_id: currentInventoryId,
//             property_id: selectedProperty.id,
//             quantity: Number(item.quantity),
//             min_quantity: Number(item.min_quantity),
//             max_quantity: Number(item.max_quantity),
//             cost_per_unit: Number(item.cost_per_unit),
//             sku: item.sku,
//           };
//           await createInventoryItem(itemPayload);
//         }
//       }

//       // Save current item if not already in pending items
//       if (!pendingItems.some((item) => item.sku[0] === values.sku)) {
//         const itemPayload = {
//           ...values,
//           inventory_id: currentInventoryId,
//           property_id: selectedProperty.id,
//           quantity: Number(values.quantity),
//           min_quantity: Number(values.min_quantity),
//           max_quantity: Number(values.max_quantity),
//           cost_per_unit: Number(values.cost_per_unit),
//           sku: [values.sku],
//         };
//         await createInventoryItem(itemPayload);
//       }

//       toast.success('Items saved successfully');
//       setModalOpen(false);
//       setIsEditing(false);
//       setPendingItems([]);
//       localStorage.removeItem('pendingItems');
//       await getInventoryData(selectedProperty.id, selectedBuilding);
//       resetForm();
//     } catch (error) {
//       console.error('Error adding items:', error);
//       toast.error(error.message || 'Failed to add items. Please check the form data and try again.');
//     } finally {
//       setLoading(false);
//       setSubmitting(false);
//     }
//   };

//   // Update an existing item
//   const handleUpdateSubmit = async (values, { setSubmitting }) => {
//     setLoading(true);
//     try {
//       const updatePayload = {
//         request_type: values.request_type,
//         name: values.name,
//         sku: [values.sku],
//         description: values.description,
//         quantity: Number(values.quantity),
//         min_quantity: Number(values.min_quantity),
//         max_quantity: Number(values.max_quantity),
//         cost_per_unit: Number(values.cost_per_unit),
//         is_active: values.is_active,
//         recurring: values.recurring,
//         location_details: {
//           floor: values.location_details?.floor || '',
//           room: values.location_details?.room || '',
//           section: values.location_details?.section || '',
//           shelf: values.location_details?.shelf || '',
//           bin: values.location_details?.bin || '',
//           notes: values.location_details?.notes || '',
//         },
//         invoice_details: {
//           invoice_url: values.invoice_details?.invoice_url || '',
//           warranty_details: {
//             valid_till: values.invoice_details?.warranty_details?.valid_till || '',
//             provider: values.invoice_details?.warranty_details?.provider || '',
//             contact: values.invoice_details?.warranty_details?.contact || '',
//             notes: values.invoice_details?.warranty_details?.notes || '',
//           },
//         },
//         building_name: selectedBuilding,
//       };
//       await updateInventoryItem(selectedInventory._id, updatePayload);
//       toast.success('Item updated successfully');
//       setDetailModalOpen(false);
//       setIsEditing(false);
//       await getInventoryData(selectedProperty.id, selectedBuilding);
//     } catch (error) {
//       console.error('Error updating item:', error);
//       toast.error(error.message || 'Failed to update item. Please try again.');
//     } finally {
//       setLoading(false);
//       setSubmitting(false);
//     }
//   };

//   // Delete an item
//   const handleDelete = async () => {
//     setLoading(true);
//     try {
//       await deleteInventoryItem(selectedInventory._id);
//       toast.success('Item deleted successfully');
//       setDeleteModalOpen(false);
//       await getInventoryData(selectedProperty.id, selectedBuilding);
//     } catch (error) {
//       console.error('Error deleting item:', error);
//       toast.error(error.message || 'Failed to delete item. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Create an order
//   const handleCreateOrder = async (item) => {
//     setLoading(true);
//     try {
//       await createOrder({ inventory_item_id: item._id, quantity: 1 });
//       toast.success('Order created successfully');
//       await getInventoryData(selectedProperty.id, selectedBuilding);
//     } catch (error) {
//       console.error('Error creating order:', error);
//       toast.error(error.message || 'Failed to create order. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Table columns
//   const columns = [
//     {
//       dataField: 'name',
//       text: 'Name',
//       sort: true,
//     },
//     {
//       dataField: 'sku',
//       text: 'SKU',
//       formatter: (cell) => (cell ? cell.join(', ') : 'N/A'),
//     },
//     {
//       dataField: 'building_name',
//       text: 'Building Name',
//       sort: true,
//     },
//     {
//       dataField: 'quantity',
//       text: 'Quantity',
//       sort: true,
//     },
//     {
//       dataField: 'min_quantity',
//       text: 'Min Quantity',
//       sort: true,
//     },
//     {
//       dataField: 'max_quantity',
//       text: 'Max Quantity',
//       sort: true,
//     },
//     {
//       dataField: 'is_active',
//       text: 'Active',
//       formatter: (cell) => (cell ? 'Yes' : 'No'),
//     },
//     {
//       dataField: 'actions',
//       text: 'Actions',
//       formatter: (cell, row) => (
//         <Box display="flex" gap={1}>
//           <IconButton
//             onClick={() => {
//               setSelectedInventory(row);
//               setDetailModalOpen(true);
//             }}
//             title="View"
//           >
//             <FeatherIcon icon="eye" size={20} />
//           </IconButton>
//           <IconButton
//             onClick={() => {
//               setSelectedInventory(row);
//               setDeleteModalOpen(true);
//             }}
//             title="Delete"
//           >
//             <FeatherIcon icon="trash-2" size={20} color="red" />
//           </IconButton>
//           <IconButton
//             onClick={() => handleCreateOrder(row)}
//             title="Create Order"
//             disabled={loading}
//           >
//             <FeatherIcon icon="shopping-cart" size={20} />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   const paginationOptions = {
//     sizePerPage: 10,
//     hideSizePerPage: true,
//     hidePageListOnlyOnePage: true,
//   };

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <MetaTags>
//           <title>Rentdigicare | Inventory Listing</title>
//         </MetaTags>
//         <div className="container-fluid">
//           <Breadcrumb title="Home" breadcrumbItem="Inventory" />
//           <ToastContainer />

//           <div className="row">
//             <div className="col-12">
//               <Card className="miui-card">
//                 <CardContent>
//                   <Box display="flex" justifyContent="space-between" mb={3}>
//                     <Typography variant="h4">Inventory</Typography>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="miui-button"
//                       onClick={() => setModalOpen(true)}
//                       disabled={loading || !selectedBuilding}
//                     >
//                       Add Inventory
//                     </Button>
//                   </Box>

//                   {/* Property and Building Selection */}
//                   <Box mb={3}>
//                     <Grid container spacing={2}>
//                       <Grid item xs={6}>
//                         <FormControl fullWidth>
//                           <InputLabel>Select Property</InputLabel>
//                           <Select
//                             value={selectedProperty?.id || ''}
//                             onChange={handlePropertyChange}
//                             label="Select Property"
//                             disabled={loading}
//                           >
//                             <MenuItem value="">
//                               <em>Select a property</em>
//                             </MenuItem>
//                             {propertyList.map((prop) => (
//                               <MenuItem key={prop._id} value={prop._id}>
//                                 {prop.title}, {prop.location}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>
//                       {buildingList.length > 0 && (
//                         <Grid item xs={6}>
//                           <FormControl fullWidth>
//                             <InputLabel>Select Building</InputLabel>
//                             <Select
//                               value={selectedBuilding}
//                               onChange={handleBuildingChange}
//                               label="Select Building"
//                               disabled={loading}
//                             >
//                               <MenuItem value="">
//                                 <em>Select a building</em>
//                               </MenuItem>
//                               {buildingList.map((building, index) => (
//                                 <MenuItem key={index} value={building}>
//                                   {building}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         </Grid>
//                       )}
//                     </Grid>
//                   </Box>

//                   {loading ? (
//                     <Box className="loader-container">
//                       <CircularProgress />
//                     </Box>
//                   ) : (
//                     <div className="miui-table scrollable-table">
//                       <BootstrapTable
//                         keyField="_id"
//                         data={inventories}
//                         columns={columns}
//                         pagination={paginationFactory(paginationOptions)}
//                         bootstrap4
//                         striped
//                         hover
//                         condensed
//                       />
//                     </div>
//                   )}
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add Items Dialog */}
//       <Dialog
//         open={modalOpen}
//         onClose={() => {
//           setModalOpen(false);
//           setIsEditing(false);
//         }}
//         className="miui-dialog"
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Add New Item {pendingItems.length > 0 && `(${pendingItems.length} pending)`}
//         </DialogTitle>
//         <Formik
//           initialValues={{
//             request_type: '',
//             name: '',
//             sku: '',
//             building_name: selectedBuilding || '',
//             description: '',
//             quantity: 0,
//             min_quantity: 0,
//             max_quantity: 0,
//             cost_per_unit: 0,
//             is_active: true,
//             recurring: false,
//             location_details: {
//               floor: '',
//               room: '',
//               section: '',
//               shelf: '',
//               bin: '',
//               notes: '',
//             },
//             invoice_details: {
//               invoice_url: '',
//               warranty_details: {
//                 valid_till: '',
//                 provider: '',
//                 contact: '',
//                 notes: '',
//               },
//             },
//           }}
//           validationSchema={validationSchema}
//           validateOnChange={true}
//           validateOnBlur={true}
//           onSubmit={handleAddSubmit}
//         >
//           {({ errors, touched, values, isSubmitting, resetForm }) => (
//             <Form>
//               <DialogContent>
//                 <Box className="miui-form-field">
//                   <FormControl fullWidth>
//                     <InputLabel>Request Type</InputLabel>
//                     <Field
//                       as={Select}
//                       name="request_type"
//                       label="Request Type"
//                       error={touched.request_type && !!errors.request_type}
//                       disabled={isSubmitting || loading}
//                     >
//                       <MenuItem value="">
//                         <em>Select a request type</em>
//                       </MenuItem>
//                       {requestTypes.map((type) => (
//                         <MenuItem key={type._id} value={type.request_type}>
//                           {type.request_type}
//                         </MenuItem>
//                       ))}
//                     </Field>
//                     {touched.request_type && errors.request_type && (
//                       <Typography color="error" variant="caption">
//                         {errors.request_type}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="name"
//                     label="Name"
//                     fullWidth
//                     error={touched.name && !!errors.name}
//                     helperText={touched.name && errors.name}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="sku"
//                     label="SKU"
//                     fullWidth
//                     error={touched.sku && !!errors.sku}
//                     helperText={touched.sku && errors.sku}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="building_name"
//                     label="Building Name"
//                     fullWidth
//                     value={selectedBuilding}
//                     disabled
//                   />
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="description"
//                     label="Description"
//                     multiline
//                     rows={4}
//                     fullWidth
//                     error={touched.description && !!errors.description}
//                     helperText={touched.description && errors.description}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={4}>
//                       <Field
//                         as={TextField}
//                         name="quantity"
//                         label="Quantity"
//                         type="number"
//                         fullWidth
//                         error={touched.quantity && !!errors.quantity}
//                         helperText={touched.quantity && errors.quantity}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Field
//                         as={TextField}
//                         name="min_quantity"
//                         label="Min Quantity"
//                         type="number"
//                         fullWidth
//                         error={touched.min_quantity && !!errors.min_quantity}
//                         helperText={touched.min_quantity && errors.min_quantity}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Field
//                         as={TextField}
//                         name="max_quantity"
//                         label="Max Quantity"
//                         type="number"
//                         fullWidth
//                         error={touched.max_quantity && !!errors.max_quantity}
//                         helperText={touched.max_quantity && errors.max_quantity}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="cost_per_unit"
//                     label="Cost Per Unit"
//                     type="number"
//                     fullWidth
//                     error={touched.cost_per_unit && !!errors.cost_per_unit}
//                     helperText={touched.cost_per_unit && errors.cost_per_unit}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <FormControlLabel
//                         control={
//                           <Field
//                             as={Checkbox}
//                             name="is_active"
//                             checked={values.is_active}
//                             disabled={isSubmitting || loading}
//                           />
//                         }
//                         label="Is Active"
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <FormControlLabel
//                         control={
//                           <Field
//                             as={Checkbox}
//                             name="recurring"
//                             checked={values.recurring}
//                             disabled={isSubmitting || loading}
//                           />
//                         }
//                         label="Recurring"
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                   Location Details
//                 </Typography>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="location_details.floor"
//                         label="Floor"
//                         fullWidth
//                         error={touched.location_details?.floor && !!errors.location_details?.floor}
//                         helperText={touched.location_details?.floor && errors.location_details?.floor}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="location_details.room"
//                         label="Room"
//                         fullWidth
//                         error={touched.location_details?.room && !!errors.location_details?.room}
//                         helperText={touched.location_details?.room && errors.location_details?.room}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="location_details.section"
//                         label="Section"
//                         fullWidth
//                         error={touched.location_details?.section && !!errors.location_details?.section}
//                         helperText={touched.location_details?.section && errors.location_details?.section}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="location_details.shelf"
//                         label="Shelf"
//                         fullWidth
//                         error={touched.location_details?.shelf && !!errors.location_details?.shelf}
//                         helperText={touched.location_details?.shelf && errors.location_details?.shelf}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="location_details.bin"
//                         label="Bin"
//                         fullWidth
//                         error={touched.location_details?.bin && !!errors.location_details?.bin}
//                         helperText={touched.location_details?.bin && errors.location_details?.bin}
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="location_details.notes"
//                     numberOfLines={4}
//                     label="Notes"
//                     multiline
//                     rows={4}
//                     fullWidth
//                     error={touched.location_details?.notes && !!errors.location_details?.notes}
//                     helperText={touched.location_details?.notes && errors.location_details?.notes}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>

//                 <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                   Invoice Details
//                 </Typography>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="invoice_details.invoice_url"
//                     label="Invoice URL"
//                     fullWidth
//                     error={touched.invoice_details?.invoice_url && !!errors.invoice_details?.invoice_url}
//                     helperText={touched.invoice_details?.invoice_url && errors.invoice_details?.invoice_url}
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>

//                 <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                   Warranty Details
//                 </Typography>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="invoice_details.warranty_details.valid_till"
//                         label="Valid Till"
//                         type="date"
//                         InputLabelProps={{ shrink: true }}
//                         fullWidth
//                         error={
//                           touched.invoice_details?.warranty_details?.valid_till &&
//                           !!errors.invoice_details?.warranty_details?.valid_till
//                         }
//                         helperText={
//                           touched.invoice_details?.warranty_details?.valid_till &&
//                           errors.invoice_details?.warranty_details?.valid_till
//                         }
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="invoice_details.warranty_details.provider"
//                         label="Provider"
//                         fullWidth
//                         error={
//                           touched.invoice_details?.warranty_details?.provider &&
//                           !!errors.invoice_details?.warranty_details?.provider
//                         }
//                         helperText={
//                           touched.invoice_details?.warranty_details?.provider &&
//                           errors.invoice_details?.warranty_details?.provider
//                         }
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Field
//                         as={TextField}
//                         name="invoice_details.warranty_details.contact"
//                         label="Contact"
//                         fullWidth
//                         error={
//                           touched.invoice_details?.warranty_details?.contact &&
//                           !!errors.invoice_details?.warranty_details?.contact
//                         }
//                         helperText={
//                           touched.invoice_details?.warranty_details?.contact &&
//                           errors.invoice_details?.warranty_details?.contact
//                         }
//                         disabled={isSubmitting || loading}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//                 <Box className="miui-form-field">
//                   <Field
//                     as={TextField}
//                     name="invoice_details.warranty_details.notes"
//                     label="Notes"
//                     multiline
//                     rows={4}
//                     fullWidth
//                     error={
//                       touched.invoice_details?.warranty_details?.notes &&
//                       !!errors.invoice_details?.warranty_details?.notes
//                     }
//                     helperText={
//                       touched.invoice_details?.warranty_details?.notes &&
//                       errors.invoice_details?.warranty_details?.notes
//                     }
//                     disabled={isSubmitting || loading}
//                   />
//                 </Box>
//               </DialogContent>
//               <DialogActions>
//                 <Button
//                   variant="outlined"
//                   className="miui-button"
//                   onClick={() => handleAddMoreItem(values, { resetForm })}
//                   disabled={isSubmitting || loading}
//                 >
//                   Add More Item
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   className="miui-button"
//                   onClick={() => {
//                     setModalOpen(false);
//                     setIsEditing(false);
//                   }}
//                   disabled={isSubmitting || loading}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   color="primary"
//                   className="miui-button"
//                   disabled={isSubmitting || loading}
//                 >
//                   {loading ? <CircularProgress size={24} /> : 'Save Items'}
//                 </Button>
//               </DialogActions>
//             </Form>
//           )}
//         </Formik>
//       </Dialog>

//       {/* Detail/Edit Dialog */}
//       <Dialog
//         open={detailModalOpen}
//         onClose={() => {
//           setDetailModalOpen(false);
//           setIsEditing(false);
//         }}
//         className="miui-dialog"
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Item Details</Typography>
//             {!isEditing && (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 className="miui-button"
//                 onClick={() => setIsEditing(true)}
//                 disabled={loading}
//               >
//                 <FeatherIcon icon="edit" className="me-2" />
//                 Edit Item
//               </Button>
//             )}
//           </Box>
//         </DialogTitle>
//         {selectedInventory && (
//           <Formik
//             initialValues={{
//               request_type: selectedInventory.request_type || '',
//               name: selectedInventory.name || '',
//               sku: selectedInventory.sku?.[0] || '',
//               building_name: selectedInventory.building_name || selectedBuilding,
//               description: selectedInventory.description || '',
//               quantity: selectedInventory.quantity || 0,
//               min_quantity: selectedInventory.min_quantity || 0,
//               max_quantity: selectedInventory.max_quantity || 0,
//               cost_per_unit: selectedInventory.cost_per_unit || 0,
//               is_active: selectedInventory.is_active || false,
//               recurring: selectedInventory.recurring || false,
//               location_details: {
//                 floor: selectedInventory.location_details?.floor || '',
//                 room: selectedInventory.location_details?.room || '',
//                 section: selectedInventory.location_details?.section || '',
//                 shelf: selectedInventory.location_details?.shelf || '',
//                 bin: selectedInventory.location_details?.bin || '',
//                 notes: selectedInventory.location_details?.notes || '',
//               },
//               invoice_details: {
//                 invoice_url: selectedInventory.invoice_details?.invoice_url || '',
//                 warranty_details: {
//                   valid_till: selectedInventory.invoice_details?.warranty_details?.valid_till
//                     ? new Date(selectedInventory.invoice_details.warranty_details.valid_till)
//                         .toISOString()
//                         .split('T')[0]
//                     : '',
//                   provider: selectedInventory.invoice_details?.warranty_details?.provider || '',
//                   contact: selectedInventory.invoice_details?.warranty_details?.contact || '',
//                   notes: selectedInventory.invoice_details?.warranty_details?.notes || '',
//                 },
//               },
//             }}
//             validationSchema={validationSchema}
//             validateOnChange={true}
//             validateOnBlur={true}
//             onSubmit={handleUpdateSubmit}
//           >
//             {({ errors, touched, values, isSubmitting }) => (
//               <Form>
//                 <DialogContent>
//                   {isEditing ? (
//                     <>
//                       <Box className="miui-form-field">
//                         <FormControl fullWidth>
//                           <InputLabel>Request Type</InputLabel>
//                           <Field
//                             as={Select}
//                             name="request_type"
//                             label="Request Type"
//                             error={touched.request_type && !!errors.request_type}
//                             disabled={isSubmitting || loading}
//                           >
//                             <MenuItem value="">
//                               <em>Select a request type</em>
//                             </MenuItem>
//                             {requestTypes.map((type) => (
//                               <MenuItem key={type._id} value={type.request_type}>
//                                 {type.request_type}
//                               </MenuItem>
//                             ))}
//                           </Field>
//                           {touched.request_type && errors.request_type && (
//                             <Typography color="error" variant="caption">
//                               {errors.request_type}
//                             </Typography>
//                           )}
//                         </FormControl>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="name"
//                           label="Name"
//                           fullWidth
//                           error={touched.name && !!errors.name}
//                           helperText={touched.name && errors.name}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="sku"
//                           label="SKU"
//                           fullWidth
//                           error={touched.sku && !!errors.sku}
//                           helperText={touched.sku && errors.sku}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="building_name"
//                           label="Building Name"
//                           fullWidth
//                           value={selectedBuilding}
//                           disabled
//                         />
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="description"
//                           label="Description"
//                           multiline
//                           rows={4}
//                           fullWidth
//                           error={touched.description && !!errors.description}
//                           helperText={touched.description && errors.description}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={4}>
//                             <Field
//                               as={TextField}
//                               name="quantity"
//                               label="Quantity"
//                               type="number"
//                               fullWidth
//                               error={touched.quantity && !!errors.quantity}
//                               helperText={touched.quantity && errors.quantity}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                           <Grid item xs={4}>
//                             <Field
//                               as={TextField}
//                               name="min_quantity"
//                               label="Min Quantity"
//                               type="number"
//                               fullWidth
//                               error={touched.min_quantity && !!errors.min_quantity}
//                               helperText={touched.min_quantity && errors.min_quantity}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                           <Grid item xs={4}>
//                             <Field
//                               as={TextField}
//                               name="max_quantity"
//                               label="Max Quantity"
//                               type="number"
//                               fullWidth
//                               error={touched.max_quantity && !!errors.max_quantity}
//                               helperText={touched.max_quantity && errors.max_quantity}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="cost_per_unit"
//                           label="Cost Per Unit"
//                           type="number"
//                           fullWidth
//                           error={touched.cost_per_unit && !!errors.cost_per_unit}
//                           helperText={touched.cost_per_unit && errors.cost_per_unit}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <FormControlLabel
//                               control={
//                                 <Field
//                                   as={Checkbox}
//                                   name="is_active"
//                                   checked={values.is_active}
//                                   disabled={isSubmitting || loading}
//                                 />
//                               }
//                               label="Is Active"
//                             />
//                           </Grid>
//                           <Grid item xs={6}>
//                             <FormControlLabel
//                               control={
//                                 <Field
//                                   as={Checkbox}
//                                   name="recurring"
//                                   checked={values.recurring}
//                                   disabled={isSubmitting || loading}
//                                 />
//                               }
//                               label="Recurring"
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>

//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                         Location Details
//                       </Typography>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="location_details.floor"
//                               label="Floor"
//                               fullWidth
//                               error={touched.location_details?.floor && !!errors.location_details?.floor}
//                               helperText={touched.location_details?.floor && errors.location_details?.floor}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="location_details.room"
//                               label="Room"
//                               fullWidth
//                               error={touched.location_details?.room && !!errors.location_details?.room}
//                               helperText={touched.location_details?.room && errors.location_details?.room}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="location_details.section"
//                               label="Section"
//                               fullWidth
//                               error={touched.location_details?.section && !!errors.location_details?.section}
//                               helperText={touched.location_details?.section && errors.location_details?.section}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="location_details.shelf"
//                               label="Shelf"
//                               fullWidth
//                               error={touched.location_details?.shelf && !!errors.location_details?.shelf}
//                               helperText={touched.location_details?.shelf && errors.location_details?.shelf}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="location_details.bin"
//                               label="Bin"
//                               fullWidth
//                               error={touched.location_details?.bin && !!errors.location_details?.bin}
//                               helperText={touched.location_details?.bin && errors.location_details?.bin}
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="location_details.notes"
//                           label="Notes"
//                           multiline
//                           rows={4}
//                           fullWidth
//                           error={touched.location_details?.notes && !!errors.location_details?.notes}
//                           helperText={touched.location_details?.notes && errors.location_details?.notes}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>

//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                         Invoice Details
//                       </Typography>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="invoice_details.invoice_url"
//                           label="Invoice URL"
//                           fullWidth
//                           error={touched.invoice_details?.invoice_url && !!errors.invoice_details?.invoice_url}
//                           helperText={touched.invoice_details?.invoice_url && errors.invoice_details?.invoice_url}
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>

//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                         Warranty Details
//                       </Typography>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="invoice_details.warranty_details.valid_till"
//                               label="Valid Till"
//                               type="date"
//                               InputLabelProps={{ shrink: true }}
//                               fullWidth
//                               error={
//                                 touched.invoice_details?.warranty_details?.valid_till &&
//                                 !!errors.invoice_details?.warranty_details?.valid_till
//                               }
//                               helperText={
//                                 touched.invoice_details?.warranty_details?.valid_till &&
//                                 errors.invoice_details?.warranty_details?.valid_till
//                               }
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="invoice_details.warranty_details.provider"
//                               label="Provider"
//                               fullWidth
//                               error={
//                                 touched.invoice_details?.warranty_details?.provider &&
//                                 !!errors.invoice_details?.warranty_details?.provider
//                               }
//                               helperText={
//                                 touched.invoice_details?.warranty_details?.provider &&
//                                 errors.invoice_details?.warranty_details?.provider
//                               }
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Grid container spacing={2}>
//                           <Grid item xs={6}>
//                             <Field
//                               as={TextField}
//                               name="invoice_details.warranty_details.contact"
//                               label="Contact"
//                               fullWidth
//                               error={
//                                 touched.invoice_details?.warranty_details?.contact &&
//                                 !!errors.invoice_details?.warranty_details?.contact
//                               }
//                               helperText={
//                                 touched.invoice_details?.warranty_details?.contact &&
//                                 errors.invoice_details?.warranty_details?.contact
//                               }
//                               disabled={isSubmitting || loading}
//                             />
//                           </Grid>
//                         </Grid>
//                       </Box>
//                       <Box className="miui-form-field">
//                         <Field
//                           as={TextField}
//                           name="invoice_details.warranty_details.notes"
//                           label="Notes"
//                           multiline
//                           rows={4}
//                           fullWidth
//                           error={
//                             touched.invoice_details?.warranty_details?.notes &&
//                             !!errors.invoice_details?.warranty_details?.notes
//                           }
//                           helperText={
//                             touched.invoice_details?.warranty_details?.notes &&
//                             errors.invoice_details?.warranty_details?.notes
//                           }
//                           disabled={isSubmitting || loading}
//                         />
//                       </Box>
//                     </>
//                   ) : (
//                     <Box>
//                       <Typography><strong>Name:</strong> {selectedInventory.name || 'N/A'}</Typography>
//                       <Typography><strong>Request Type:</strong> {selectedInventory.request_type || 'N/A'}</Typography>
//                       <Typography><strong>SKU:</strong> {selectedInventory.sku?.join(', ') || 'N/A'}</Typography>
//                       <Typography><strong>Building Name:</strong> {selectedInventory.building_name || 'N/A'}</Typography>
//                       <Typography><strong>Description:</strong> {selectedInventory.description || 'N/A'}</Typography>
//                       <Typography><strong>Quantity:</strong> {selectedInventory.quantity ?? 'N/A'}</Typography>
//                       <Typography><strong>Min Quantity:</strong> {selectedInventory.min_quantity ?? 'N/A'}</Typography>
//                       <Typography><strong>Max Quantity:</strong> {selectedInventory.max_quantity ?? 'N/A'}</Typography>
//                       <Typography><strong>Cost Per Unit:</strong> {selectedInventory.cost_per_unit ?? 'N/A'}</Typography>
//                       <Typography><strong>Active:</strong> {selectedInventory.is_active ? 'Yes' : 'No'}</Typography>
//                       <Typography><strong>Recurring:</strong> {selectedInventory.recurring ? 'Yes' : 'No'}</Typography>
//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Location Details</Typography>
//                       <Typography><strong>Floor:</strong> {selectedInventory.location_details?.floor || 'N/A'}</Typography>
//                       <Typography><strong>Room:</strong> {selectedInventory.location_details?.room || 'N/A'}</Typography>
//                       <Typography><strong>Section:</strong> {selectedInventory.location_details?.section || 'N/A'}</Typography>
//                       <Typography><strong>Shelf:</strong> {selectedInventory.location_details?.shelf || 'N/A'}</Typography>
//                       <Typography><strong>Bin:</strong> {selectedInventory.location_details?.bin || 'N/A'}</Typography>
//                       <Typography><strong>Notes:</strong> {selectedInventory.location_details?.notes || 'N/A'}</Typography>
//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Invoice Details</Typography>
//                       <Typography><strong>Invoice URL:</strong> {selectedInventory.invoice_details?.invoice_url || 'N/A'}</Typography>
//                       <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Warranty Details</Typography>
//                       <Typography>
//                         <strong>Valid Till:</strong>{' '}
//                         {selectedInventory.invoice_details?.warranty_details?.valid_till
//                           ? new Date(selectedInventory.invoice_details.warranty_details.valid_till).toLocaleDateString()
//                           : 'N/A'}
//                       </Typography>
//                       <Typography>
//                         <strong>Provider:</strong> {selectedInventory.invoice_details?.warranty_details?.provider || 'N/A'}
//                       </Typography>
//                       <Typography>
//                         <strong>Contact:</strong> {selectedInventory.invoice_details?.warranty_details?.contact || 'N/A'}
//                       </Typography>
//                       <Typography>
//                         <strong>Notes:</strong> {selectedInventory.invoice_details?.warranty_details?.notes || 'N/A'}
//                       </Typography>
//                     </Box>
//                   )}
//                 </DialogContent>
//                 <DialogActions>
//                   <Button
//                     variant="outlined"
//                     className="miui-button"
//                     onClick={() => {
//                       setDetailModalOpen(false);
//                       setIsEditing(false);
//                     }}
//                     disabled={isSubmitting || loading}
//                   >
//                     Close
//                   </Button>
//                   {isEditing && (
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       className="miui-button"
//                       disabled={isSubmitting || loading}
//                     >
//                       {loading ? <CircularProgress size={24} /> : 'Update Item'}
//                     </Button>
//                   )}
//                 </DialogActions>
//               </Form>
//             )}
//           </Formik>
//         )}
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteModalOpen}
//         onClose={() => setDeleteModalOpen(false)}
//         className="miui-dialog"
//       >
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete the inventory item "{selectedInventory?.name || 'this item'}"? This
//             action cannot be undone.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="outlined"
//             className="miui-button"
//             onClick={() => setDeleteModalOpen(false)}
//             disabled={loading}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="error"
//             className="miui-button"
//             onClick={handleDelete}
//             disabled={loading}
//           >
//             {loading ? <CircularProgress size={24} /> : 'Confirm'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* No Buildings Alert Dialog */}
//       <Dialog
//         open={noBuildingsModalOpen}
//         onClose={() => setNoBuildingsModalOpen(false)}
//         className="miui-dialog"
//       >
//         <DialogTitle>No Buildings Available</DialogTitle>
//         <DialogContent>
//           <Alert severity="error">No buildings are available for the selected property.</Alert>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="outlined"
//             className="miui-button"
//             onClick={() => setNoBuildingsModalOpen(false)}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* No Inventory Alert Dialog */}
//       <Dialog
//         open={noInventoryModalOpen}
//         onClose={() => setNoInventoryModalOpen(false)}
//         className="miui-dialog"
//       >
//         <DialogTitle>No Inventory Found</DialogTitle>
//         <DialogContent>
//           <Alert severity="warning">
//             No inventory is present for the selected property and building.
//           </Alert>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="outlined"
//             className="miui-button"
//             onClick={() => setNoInventoryModalOpen(false)}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   );
// };

// export default CreateInventory;

const createInventory = () => {
  return (
    <div>createInventory</div>
  )
}

export default createInventory